<template>
  <form class="form-horizontal">
    <div class="form-group">
      <label class="col-xs-2 control-label">
        费用说明
      </label>
      <div class="col-xs-10">
        <d-editor :content.sync="route.basic.feeIntro"></d-editor>
      </div>
    </div>
    <hr>
    <div class="form-group">
      <label class="col-xs-2 control-label">
      注意事项
      </label>
      <div class="col-xs-10">
        <d-editor :content.sync="route.basic.attentions"></d-editor>
      </div>
    </div>
    <div class="page-header"><span class="glyphicon glyphicon-paperclip"></span>赞助商</div>
    <div>
      <input type="text" class="form-control" v-model="route.basic.sponsorTitle" placeholder="赞助商标题">
    </div>
    <div class="form-group" v-for="item in route.routeSponsor" track-by="$index">
      <div class="col-xs-12">
        <button type="button" class="close" @click="route.routeSponsor.$remove(item)">&times;</button>
      </div>
      <div class="col-xs-2">
        <d-upload :url.sync="item.pic" class="btn btn-primary btn-block btn-xs">上传图片</d-upload>
        <img class="img-responsive ng-hide" style="margin-top: 5px;" v-show="item.pic" :src="item.pic">
      </div>
      <div class="col-xs-10">
        <input class="form-control" name="title[]" type="text" placeholder="标题" v-model="item.title">
        <textarea class="form-control" name="introduce[]" v-model="item.intro" rows="4" style="margin-top: 10px;" placeholder="内容"></textarea>
      </div>
    </div>
    <div class="form-group">
      <div class="col-xs-12 text-center">
        <button type="button" class="btn btn-default" @click="route.routeSponsor.push({
          intro: '',
          pic: '',
          title: ''
        })">添加</button>
      </div>
    </div>
    <div class="form-group">
      <div class="col-xs-12 text-center">
        <button type="button" @click="click(submit)($event)" class="btn btn-primary">保存</button>
        <button type="button" @click="click(submit)($event, '/route/' + this.$route.params.id + '/images')" class="btn btn-success">保存并下一步</button>
      </div>
    </div>
  </form>
</template>
<script>
  import config from '../../libs/config'
  import utils from '../../libs/utils'
  import { pick } from 'lodash'
  import dUpload from '../../components/Upload'
  import dEditor from '../../components/Editor'

  export default {
    props: ['route'],
    components: {
      dUpload,
      dEditor
    },
    methods: {
      updateBasic () {
        let data = pick(this.route.basic, ['attentions', 'feeIntro', 'sponsorTitle'])
        return this.$http.put(`${config.apiWe}/product/route/${this.$route.params.id}`, data)
      },
      updateSponsor () {
        let data = {
          routeSponsors: this.route.routeSponsor.map(({title, intro, pic}) => {
            return {
              title,
              intro,
              pic
            }
          })
        }

        return this.$http.put(`${config.apiWe}/product/route/${this.$route.params.id}/sponsor`, data)
      },
      submit (next) {
        return Promise.all([this.updateBasic(), this.updateSponsor()])
          .then(() => {
            next && next && this.$route.router.go(next)
          })
      },
      click: utils.click
    }
  }
</script>
<style>
</style>



/** WEBPACK FOOTER **
 ** Notice.vue?cf4c43a4
 **/